export const companyAddressesDict = {
  en: [
    {
      '@type': 'PostalAddress',
      addressLocality: 'Vienna',
      addressCountry: 'AT',
      postalCode: '1010',
      streetAddress: 'Rathausplatz 8, office 7',
      telephone: '+43 (670) 308-21-75',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Istanbul',
      addressCountry: 'TR',
      postalCode: '34381',
      streetAddress:
        'Izzetpasa Mahallesi Yeniyol Caddesi No: 3 Nurol Tower Ofis 1208 Şişli',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'St Julian’s',
      addressCountry: 'MT',
      postalCode: 'STJ 3141',
      streetAddress:
        "8/2, Portomaso Business Tower, 1 Church Street, St Julian's, STJ 4011",
      telephone: '+356 2033 0178',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Lisbon',
      addressCountry: 'PT',
      postalCode: '1250-161',
      streetAddress: 'Avenida Fontes Pereira de Melo 25, 3 Esq 1050-116',
      telephone: '+351 211 234 321',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'St. Andrew',
      addressCountry: 'GD',
      streetAddress: 'Victoria Street, Grenville',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Astana',
      addressCountry: 'KZ',
      streetAddress: 'st. D. Kunaeva, 29/1, BC Diplomat',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Athens',
      addressCountry: 'GR',
      postalCode: '114 74',
      streetAddress: '91 Alexandras Ave',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Limassol',
      addressCountry: 'CY',
      postalCode: '3030',
      streetAddress: 'Victory House, 205, Archbishop Makarios Avenue',
      telephone: '+43 (670) 308-25-71',
    },
  ],
  ru: [
    {
      '@type': 'PostalAddress',
      addressLocality: 'Вена',
      addressCountry: 'AT',
      postalCode: '1010',
      streetAddress: 'Rathausplatz 8, office 7',
      telephone: '+43 (670) 308-21-75',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Стамбул',
      addressCountry: 'TR',
      postalCode: '34381',
      streetAddress:
        'Izzetpasa Mahallesi Yeniyol Caddesi No: 3 Nurol Tower Ofis 1208 Şişli',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Сент-Джулианс',
      addressCountry: 'MT',
      postalCode: 'STJ 3141',
      streetAddress:
        "8/2, Portomaso Business Tower, 1 Church Street, St Julian's, STJ 4011",
      telephone: '+356 2033 0178',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Лиссабон',
      addressCountry: 'PT',
      postalCode: '1250-161',
      streetAddress: 'Avenida Fontes Pereira de Melo 25, 3 Esq 1050-116',
      telephone: '+351 211 234 321',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Сент-Эндрю',
      addressCountry: 'GD',
      streetAddress: 'Victoria Street, Grenville',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Астана',
      addressCountry: 'KZ',
      streetAddress: 'ул. Д. Кунаева, 29/1, БЦ Дипломат',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Афины',
      addressCountry: 'GR',
      postalCode: '114 74',
      streetAddress: '91 Alexandras Ave',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Лимассол',
      addressCountry: 'CY',
      postalCode: '3030',
      streetAddress: 'Victory House, 205, Archbishop Makarios Avenue',
      telephone: '+43 (670) 308-25-71',
    },
  ],
  de: [
    {
      '@type': 'PostalAddress',
      addressLocality: 'Wien',
      addressCountry: 'AT',
      postalCode: '1010',
      streetAddress: 'Rathausplatz 8, office 7',
      telephone: '+43 (670) 308-21-75',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Istanbul',
      addressCountry: 'TR',
      postalCode: '34381',
      streetAddress:
        'Izzetpasa Mahallesi Yeniyol Caddesi No: 3 Nurol Tower Ofis 1208 Şişli',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'St. Julian’s',
      addressCountry: 'MT',
      postalCode: 'STJ 3141',
      streetAddress:
        "8/2, Portomaso Business Tower, 1 Church Street, St Julian's, STJ 4011",
      telephone: '+356 2033 0178',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Lissabon',
      addressCountry: 'PT',
      postalCode: '1250-161',
      streetAddress: 'Avenida Fontes Pereira de Melo 25, 3 Esq 1050-116',
      telephone: '+351 211 234 321',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'St. Andrew, Grenada',
      addressCountry: 'GD',
      streetAddress: 'Victoria Street, Grenville',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Astana',
      addressCountry: 'KZ',
      streetAddress: 'st. D. Kunaeva, 29/1, BC Diplomat',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Athen',
      addressCountry: 'GR',
      postalCode: '114 74',
      streetAddress: '91 Alexandras Ave',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Limassol',
      addressCountry: 'CY',
      postalCode: '3030',
      streetAddress: 'Victory House, 205, Archbishop Makarios Avenue',
      telephone: '+43 (670) 308-25-71',
    },
  ],
  tr: [
    {
      '@type': 'PostalAddress',
      addressLocality: 'Viyana',
      addressCountry: 'AT',
      postalCode: '1010',
      streetAddress: 'Rathausplatz 8, office 7',
      telephone: '+43 (670) 308-21-75',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'İstanbul',
      addressCountry: 'TR',
      postalCode: '34381',
      streetAddress:
        'Izzetpasa Mahallesi Yeniyol Caddesi No: 3 Nurol Tower Ofis 1208 Şişli',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'St. Julian’s',
      addressCountry: 'MT',
      postalCode: 'STJ 3141',
      streetAddress:
        "8/2, Portomaso Business Tower, 1 Church Street, St Julian's, STJ 4011",
      telephone: '+356 2033 0178',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Lizbon',
      addressCountry: 'PT',
      postalCode: '1250-161',
      streetAddress: 'Avenida Fontes Pereira de Melo 25, 3 Esq 1050-116',
      telephone: '+351 211 234 321',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'St. Andrew',
      addressCountry: 'GD',
      streetAddress: 'Victoria Street, Grenville',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Astana',
      addressCountry: 'KZ',
      streetAddress: 'st. D. Kunaeva, 29/1, BC Diplomat',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Atina',
      addressCountry: 'GR',
      postalCode: '114 74',
      streetAddress: '91 Alexandras Ave',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Limasol',
      addressCountry: 'CY',
      postalCode: '3030',
      streetAddress: 'Victory House, 205, Archbishop Makarios Avenue',
      telephone: '+43 (670) 308-25-71',
    },
  ],
  es: [
    {
      '@type': 'PostalAddress',
      addressLocality: 'Viena',
      addressCountry: 'AT',
      postalCode: '1010',
      streetAddress: 'Rathausplatz 8, office 7, Vienna, 1010',
      telephone: '+43 (670) 308-21-75',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Estambul',
      addressCountry: 'TR',
      postalCode: '34381',
      streetAddress:
        'Izzetpasa Mahallesi Yeniyol Caddesi No: 3 Nurol Tower Ofis 1208 Şişli',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'San Julián',
      addressCountry: 'MT',
      postalCode: 'STJ 3141',
      streetAddress:
        "8/2, Portomaso Business Tower, 1 Church Street, St Julian's, STJ 4011",
      telephone: '+356 2033 0178',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Lisboa',
      addressCountry: 'PT',
      postalCode: '1250-161',
      streetAddress: 'Avenida Fontes Pereira de Melo 25, 3 Esq 1050-116',
      telephone: '+351 211 234 321',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'St. Andrew',
      addressCountry: 'GD',
      streetAddress: 'Victoria Street, Grenville',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Astaná',
      addressCountry: 'KZ',
      streetAddress: 'st. D. Kunaeva, 29/1, BC Diplomat',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Atenas',
      addressCountry: 'GR',
      postalCode: '114 74',
      streetAddress: '91 Alexandras Ave',
    },
    {
      '@type': 'PostalAddress',
      addressLocality: 'Limassol',
      addressCountry: 'CY',
      postalCode: '3030',
      streetAddress: 'Victory House, 205, Archbishop Makarios Avenue',
      telephone: '+43 (670) 308-25-71',
    },
  ],
};
